import { useTranslation } from 'react-i18next';

import { PointerBindingRow } from 'app/modules/wallforming/components/input-binding/PointerBindingRow';

import type { InputActionId } from 'app/modules/wallforming/components/input-binding/types/inputActionId';

const POINTER_ACTIONS_COLUMN = '3.5rem';
const POINTER_TABLE_COLUMNS = `minmax(10rem, 1fr) minmax(200px, 240px) minmax(90px, 110px) ${POINTER_ACTIONS_COLUMN}`;
const POINTER_TABLE_COLUMNS_WITH_CLICK = `minmax(10rem, 1fr) minmax(200px, 240px) minmax(90px, 110px) minmax(68px, 74px) ${POINTER_ACTIONS_COLUMN}`;

export const PointerBindingTable = ({
    actionIds,
    showClickType
}: {
    actionIds: readonly InputActionId[];
    showClickType: boolean;
}) => {
    const { t } = useTranslation();
    const columns = showClickType ? POINTER_TABLE_COLUMNS_WITH_CLICK : POINTER_TABLE_COLUMNS;
    if (actionIds.length === 0) {
        return null;
    }

    return (
        <section className="mt-3">
            <div
                className="grid items-center gap-x-2 border-y border-border-ultra-light bg-background-gray-ultra-ultra-light px-4 py-1.5 font-semibold uppercase text-text-secondary"
                style={{ gridTemplateColumns: columns }}
            >
                <span>{t('labelCommand')}</span>
                <span className="text-center">{t('labelInputMouseButton')}</span>
                <span className="text-center">{t('labelInputModifier')}</span>
                {showClickType && <span className="text-center">{t('labelInputClickType')}</span>}
                <span aria-hidden="true" />
            </div>
            {actionIds.map((actionId) => (
                <PointerBindingRow key={actionId} actionId={actionId} showClickType={showClickType} />
            ))}
        </section>
    );
};
